import { PropertyType } from '../../../models/enum';
import { ContextualField } from '../../../models/ContextualField';

export const AllowLogbookEntries: ContextualField = {
    modelName: 'showLogbook',
    propertyType: PropertyType.Boolean,
    label: 'Allow logbook entries',
    placeholder: 'Allow logbook entries',
    propertyName: 'showLogbookProperty',
    required: false,
    icon: 'fa-book'
};